import moment from 'moment';
import {
  getWeekRange,
  getWeekDays,
  getInitialActiveMonth,
  reject,
  mergeNew,
} from '../../helpers';
import {
  HANDLE_TIME_ENTRY_INPUT_CHANGE,
  SUBMIT_TIME_ENTRY,
  SUBMIT_TIME_ENTRY_SUCCESS,
  SUBMIT_TIME_ENTRY_ERROR,
  UPDATE_SELECTED_DAYS,
  SET_SHOW_BULK_ENTRY_MODAL,
  ADD_TIME_ENTRY_BULK,
  ADD_TIME_ENTRY_BULK_ERROR,
  ADD_TIME_ENTRY_BULK_SUCCESS,
  LOADING_ADD_TASK,
  LOADING_ADD_TASK_ERROR,
  LOADING_ADD_TASK_SUCCESS,
  REMOVE_PROJECT_ENTRY,
  DELETE_PROJECT,
  DELETE_PROJECT_ERROR,
  DELETE_PROJECT_SUCCESS,
  LOADING_CALENDAR_COMPLETION,
  LOADING_CALENDAR_COMPLETION_ERROR,
  LOADING_CALENDAR_COMPLETION_SUCCESS,
  SETUP_CATEGORIES,
  UPDATE_HOURS_ENTERED,
} from './types';
import { UPDATE_ACTIVE_USER } from '../User/types';

const initialState = {
  projectEntries: {
    data: [],
    selectedDays: getWeekDays(getWeekRange(moment()).from),
    activeMonth: getInitialActiveMonth(),
  },
  completedWeeks: [],
  monthWorkingHours: 0,
  monthCompletedHours: 0,
  timeEntry: {
    isLoading: false,
    isError: false,
  },
  bulkEntry: {
    showModal: false,
    isLoading: false,
    isError: false,
  },
  inputEntry: {},
  addLRStatus: {
    isLoading: false,
  },
  deleteProject: {
    isLoading: false,
  },
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case LOADING_CALENDAR_COMPLETION:
      return {
        ...state,
      };
    case LOADING_CALENDAR_COMPLETION_SUCCESS:
      return {
        ...state,
        completedWeeks: [
          ...mergeNew(
            state.completedWeeks,
            action.payload.completedWeeks,
            'date'
          ),
        ],
        monthWorkingHours: action.payload.monthWorkingHours,
        monthCompletedHours: action.payload.monthCompletedHours,
      };
    case LOADING_CALENDAR_COMPLETION_ERROR:
      return {
        ...state,
      };
    case UPDATE_ACTIVE_USER:
      return {
        ...state,
        completedWeeks: [],
      };
    case UPDATE_SELECTED_DAYS:
      return {
        ...state,
        projectEntries: {
          ...state.projectEntries,
          selectedDays: state.projectEntries.selectedDays.map(
            (day, index) => action.selectedDays[index]
          ),
          activeMonth: action.activeMonth || state.projectEntries.activeMonth,
        },
      };
    case HANDLE_TIME_ENTRY_INPUT_CHANGE:
      return {
        ...state,
        inputEntry: action.inputEntry || {},
      };
    case SUBMIT_TIME_ENTRY:
      return {
        ...state,
        timeEntry: {
          ...state.timeEntry,
          isLoading: true,
        },
      };
    case SUBMIT_TIME_ENTRY_SUCCESS:
      return {
        ...state,
        timeEntry: {
          ...state.timeEntry,
          isLoading: false,
          isError: false,
        },
      };
    case SUBMIT_TIME_ENTRY_ERROR:
      return {
        ...state,
        timeEntry: {
          ...state.timeEntry,
          isLoading: false,
          isError: true,
        },
      };
    case ADD_TIME_ENTRY_BULK:
      return {
        ...state,
        bulkEntry: {
          ...state.bulkEntry,
          isLoading: true,
        },
      };
    case ADD_TIME_ENTRY_BULK_SUCCESS:
      return {
        ...state,
        bulkEntry: {
          ...state.bulkEntry,
          isLoading: false,
          isError: false,
        },
      };
    case ADD_TIME_ENTRY_BULK_ERROR:
      return {
        ...state,
        bulkEntry: {
          ...state.bulkEntry,
          isLoading: false,
          isError: true,
        },
      };
    case SET_SHOW_BULK_ENTRY_MODAL:
      return {
        ...state,
        bulkEntry: {
          ...state.bulkEntry,
          showModal: !!action.show,
        },
      };
    case LOADING_ADD_TASK:
      return { ...state, addLRStatus: { isLoading: true } };
    case LOADING_ADD_TASK_SUCCESS:
      return { ...state, addLRStatus: { isLoading: false } };
    case LOADING_ADD_TASK_ERROR:
      return { ...state, addLRStatus: { isLoading: false } };
    case REMOVE_PROJECT_ENTRY:
      return {
        ...state,
        projectEntries: {
          ...state.projectEntries,
          data: reject(
            state.projectEntries.data,
            (q) => q.projectNumber === action.projectNumber
          ),
        },
      };
    case DELETE_PROJECT:
      return { ...state, deleteProject: { isLoading: true } };
    case DELETE_PROJECT_ERROR:
      return { ...state, deleteProject: { isLoading: false } };
    case DELETE_PROJECT_SUCCESS:
      return { ...state, deleteProject: { isLoading: false } };
    case SETUP_CATEGORIES:
      return { ...state };
    case UPDATE_HOURS_ENTERED:
      return {
        ...state,
        completedWeeks: state.completedWeeks.map((week) => ({
          ...week,
          hour: (week.hour || 0) + action.payload.amount,
        })),
        monthCompletedHours: action.payload.updateCompletedMonth
          ? state.monthCompletedHours + action.payload.amount
          : state.monthCompletedHours,
      };
    default:
      return state;
  }
};
